import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar'
import { disableBackButton } from '../../ConstantComponents/Constants'
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import { Avatar, Card, CardContent, CardHeader, Chip, Divider, Grid, MenuItem, Modal, TextField, Tooltip, Backdrop } from '@mui/material';

import config from '../../../config.json'
import axios from 'axios';
import '../../../customcss/loadernew.css'

import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react';
import moment from 'moment';
import CountUp from 'react-countup';
import TimeSeriesChartComponent from './TimeSeriesChartComponent';

const BASE_URL = config.SERVER_URL

export default function HospitalPage() {
    const drawerWidth = 300;

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    /**
     * variables
     */

    const [backdropopen, setbackdropopen] = useState(true)
    const [timeseries, settimeseries] = useState([])
    const [state, setstate] = useState(0)
    const [statemaster, setstatemaster] = useState([])

    const [hospitaltotal, sethospitaltotal] = useState(0)
    const [hospitalenteric, sethospitalenteric] = useState(0)

    const [hospitalsource, sethospitalsource] = useState([])

    const [statewisestrain, setstatewisestrain] = useState([])

    const [minLabel, setminLabel] = useState(98)

    const [states, setstates] = useState([])


    const inputlabelprops = {
        style: { color: '#45a2fa', fontSize: '17px' }
    }


    function getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    function handleResize() {
        const newWidth = getScreenWidth();


        if (newWidth <= 1920 && newWidth > 1600) {
            setminLabel(99)
        } else if (newWidth <= 1600 && newWidth > 1200) {
            setminLabel(79)
        } else if (newWidth <= 1200 && newWidth > 1000) {
            setminLabel(59)
        } else if (newWidth <= 1000 && newWidth > 800) {
            setminLabel(39)
        } else if (newWidth <= 800 && newWidth > 600) {
            setminLabel(10)
        } else if (newWidth <= 600 && newWidth > 500) {
            setminLabel(19)
        } else if (newWidth <= 500 && newWidth > 400) {
            setminLabel(2)
        }

        // Your other actions on resize, e.g., update layout
    }

    window.addEventListener('resize', handleResize);

    // Call the function initially to get the initial screen width
    const initialWidth = getScreenWidth();

    useEffect(() => {
        if (initialWidth <= 1920 && initialWidth > 1600) {
            setminLabel(99)
        } else if (initialWidth <= 1600 && initialWidth > 1200) {
            setminLabel(79)
        } else if (initialWidth <= 1200 && initialWidth > 1000) {
            setminLabel(59)
        } else if (initialWidth <= 1000 && initialWidth > 800) {
            setminLabel(39)
        } else if (initialWidth <= 800 && initialWidth > 600) {
            setminLabel(10)
        } else if (initialWidth <= 600 && initialWidth > 500) {
            setminLabel(19)
        } else if (initialWidth <= 500 && initialWidth > 400) {
            setminLabel(2)
        }
    }, [])


    useEffect(() => {

        const getState = axios.post(BASE_URL + '/master/getStatesnew', {}, { withCredentials: true })
        const getPositivityCount = axios.post(BASE_URL + '/dashboard/getPositivityCard', {}, { withCredentials: true })
        const getSourceWiseCount = axios.post(BASE_URL + '/dashboard/getSourceWiseHospital', {}, { withCredentials: true })
        const getStateWiseCount = axios.post(BASE_URL + '/dashboard/getStateWiseStrainMarket', {}, { withCredentials: true })
        const getStates = axios.post(BASE_URL + "/master/getStates",
            {},
            { withCredentials: true }
        );

        Promise.all([getState, getPositivityCount, getSourceWiseCount, getStateWiseCount, getStates])
            .then(function (responses) {



                setstatemaster(responses[0].data.States)

                sethospitaltotal(responses[1].data.TotalHospital)
                sethospitalenteric(responses[1].data.EntericHospital)

                sethospitalsource(responses[2].data.Hospital)

                //console.log("resp===:", responses[3].data)
                setstatewisestrain(responses[3].data)

                setstates(responses[4].data.States)



                setbackdropopen(false)


            }).catch(function (errors) {

            });

    }, [])

    const cardShadow = 'rgba(3, 102, 214, 0.3) 0px 19px 38px, rgba(3, 102, 214, 0.3) 0px 15px 12px'

    /**
     * pie chart config
     */

    const chartdatapie = hospitalsource.map(item => ({
        value: item.sum,
        name: item.sampleSubCategoryName
    }))

    const pieoption1 = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal'
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                top: '10%',
                //padAngle: 6,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapie
            }
        ]
    };


    return (
        <>
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    backgroundColor: '#f3f4f7',
                    scrollbarWidth: 'none', // For Firefox
                    msOverflowStyle: 'none', // For Internet Explorer and Edge
                    '&::WebkitScrollbar': {
                        display: 'none', // For Chrome, Safari, and Edge
                    },
                }}>
                <Sidebar />
                <div style={{ marginTop: '100px', marginLeft: "25px" }}>

                    <Box component="main" sx={{ p: 1, backgroundColor: '#f3f4f7', height: '100%' }}>

                        <Grid container spacing={4} justifyContent="center" alignItems="center" >

                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} >
                                <div style={{
                                    backgroundColor: 'white', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', boxShadow: cardShadow
                                }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'blue' }}><CountUp end={hospitaltotal} /></h3>
                                    <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Samples Tested</h6>

                                    {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                </div>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                <div style={{
                                    backgroundColor: 'white', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', boxShadow: cardShadow
                                }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'green' }}><CountUp end={hospitalenteric} /></h3>
                                    <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Enteric Pathogens</h6>

                                    {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                <div style={{
                                    backgroundColor: 'white', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', boxShadow: cardShadow
                                }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'red' }}>{(hospitalenteric / hospitaltotal * 100).toFixed(2)}%</h3>
                                    <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Positivity</h6>

                                    {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                </div>
                            </Grid>

                        </Grid>

                        <h3 className="rubik-font" style={{ marginLeft: '15px', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', marginTop: '50px' }}>Enteric Pathogens by Source</h3>

                        <Grid container spacing={2} sx={{ paddingLeft: 2, paddingRight: 1 }} justifyContent="center" alignItems="center">
                            <Grid item xs={12} sm={12} md={12} lg={12} >
                                <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '10px', }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Clinical Sample Strains</h3>
                                    {/* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Uncooked Food</h5> */}
                                    <ReactECharts option={pieoption1} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                </div>
                            </Grid>
                        </Grid>


                    </Box>
                </div>
            </Box>
            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
                open={backdropopen}
            >
                {/* <CircularProgress color="inherit" /> */}

                <div className="boxes">
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </Backdrop>
        </>
    )
}
